import { render } from "./yandex-map_icon.vue?vue&type=template&id=16d095ff&scoped=true"
import script from "./yandex-map_icon.vue?vue&type=script&lang=js"
export * from "./yandex-map_icon.vue?vue&type=script&lang=js"

import "./yandex-map_icon.vue?vue&type=style&index=0&id=16d095ff&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d095ff"]])

export default __exports__